<template>
  <div class="container">
    <head-nav-bar title="住院报告" :fixed="true" @click-left="back" />
    <div class="list mt-header-nav">
      <van-tabs v-model="tabActive" sticky :offset-top="46" style="width:100%;">
        <van-tab title="检验报告"> </van-tab>
        <van-tab title="检查报告" v-if="!unEnabledMyExamReport"> </van-tab>
      </van-tabs>
      <DataList
        ref="dataList2"
        api="MyReport_InHospitalPage"
        :params="listParams"
        :onAutoLoad="true"
      >
        <template v-slot:item="item" v-if="tabActive == 0">
          <van-cell is-link @click="toInfo(item.obj, 2)" title-style="flex:3;">
            <div slot="title">
              <div>
                <b>单号</b>
                ：{{ item.obj.reqNo }}
              </div>
              <div>
                <b>检验目的</b>
                ：{{ item.obj.purpose }}
              </div>
              <div>
                <b>检验日期</b>
                ：{{ item.obj.date }}
              </div>
            </div>

            <van-icon
              slot="right-icon"
              name="arrow"
              style="line-height: 2rem;"
            />
          </van-cell>
        </template>
        <template v-slot:item="item" v-else>
          <van-cell is-link @click="toInfo(item.obj, 1)" title-style="flex:3;">
            <div slot="title">
              <div>
                <b>单号</b>
                ：{{ item.obj.reqNo }}
              </div>
              <div>
                <b>检查目的</b>
                ：{{ item.obj.purpose }}
              </div>
              <div>
                <b>检查日期</b>
                ：{{ item.obj.date }}
              </div>
            </div>

            <van-icon
              slot="right-icon"
              name="arrow"
              style="line-height: 2rem;"
            />
          </van-cell>
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import { List, Tag, Button, Icon, Cell, Tab, Tabs } from "vant";
import DataList from "@/components/DataList";

export default {
  components: {
    DataList,
    [List.name]: List,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      tabActive: null,
      listParams: {},
      unEnabledMyExamReport: false,
      isBeiLiuHospital: false,
      DiagnosisCardNo: "",
      InpatientId: "",
    };
  },
  watch: {
    tabActive(e) {
      if (e == 0) {
        this.listParams = {
          ReportType: 2,
          DiagnosisCardNo: this.DiagnosisCardNo,
          InpatientId: this.InpatientId,
        };
      } else {
        this.listParams = {
          ReportType: 1,
          DiagnosisCardNo: this.DiagnosisCardNo,
          InpatientId: this.InpatientId,
        };
      }
    },
  },
  created() {
    this.$post("GetWxSystemParameterInfo", {}).then(res => {
      this.unEnabledMyExamReport = res.data.unEnabledMyExamReport;
    });
    const query = this.$route.query;
    this.tabActive = query.tab || 0;
    this.DiagnosisCardNo = query.DiagnosisCardNo;
    this.InpatientId = query.InpatientId;
  },
  methods: {
    toInfo(item, type) {
      if (type === 1) {
        this.$router.push({
          name: "userInHospitalInfo",
          query: {
            Id: item.reportId,
            ReqNo: item.reqNo,
            type: type,
            DiagnosisCardNo: this.DiagnosisCardNo,
            InpatientId: this.InpatientId,
          },
        });
      } else {
        this.$router.push({
          name: "userInHospitalInspectionInfo",
          query: {
            Id: item.reportId,
            ReqNo: item.reqNo,
            type: type,
            DiagnosisCardNo: this.DiagnosisCardNo,
            InpatientId: this.InpatientId,
          },
        });
      }
    },
    back() {
      this.$router.push({
        name: "userInHospitalIndex",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list-item {
  .value {
    line-height: 2.3rem;
    color: #333;
    font-size: 0.5rem;
  }
  .van-cell__title {
    flex: 2;
  }
}
</style>
